function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Combined Shape");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons-/-Close",
  transform: "translate(-3.000000, -4.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.7781746,4.72182541 C20.363961,5.30761184 20.363961,6.25735931 19.7781746,6.84314575 L14.1204856,12.4994856 L19.7781746,18.1568542 C20.363961,18.7426407 20.363961,19.6923882 19.7781746,20.2781746 C19.1923882,20.863961 18.2426407,20.863961 17.6568542,20.2781746 L11.9994856,14.6204856 L6.34314575,20.2781746 C5.75735931,20.863961 4.80761184,20.863961 4.22182541,20.2781746 C3.63603897,19.6923882 3.63603897,18.7426407 4.22182541,18.1568542 L9.87848558,12.4994856 L4.22182541,6.84314575 C3.63603897,6.25735931 3.63603897,5.30761184 4.22182541,4.72182541 C4.80761184,4.13603897 5.75735931,4.13603897 6.34314575,4.72182541 L11.9994856,10.3784856 L17.6568542,4.72182541 C18.2426407,4.13603897 19.1923882,4.13603897 19.7781746,4.72182541 Z",
  id: "Combined-Shape"
})));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.a6c63383.svg";
export { ForwardRef as ReactComponent };